import React, { FC, useState } from 'react'
import dynamic from 'next/dynamic'
import noSSR from 'components/DynamicLoader'
import Modal from 'components/SA/Modal/v2'
import RequestCommissionConnector, {
  ConnectorProps as RequestCommissionProps,
} from '../connectors/RequestCommission'
import { updateDataLayer } from '../helpers'
import { capitalizeString } from 'lib/helpers'
import styles from './artistProfile.module.scss'
import useQA from 'hooks/useQA'
const COMMISSION_MODAL = 'commissionModal'
type LaunchModalProps = {
  closeModal: () => void
  artistId: number
  page: string
}

const LaunchModal: FC<LaunchModalProps> = (props) => {
  const CommissionModal = dynamic(
    import(
      /* webpackChunkName: "artistCommissionModal" */
      'components/RequestCommission/CommissionModal'
    ),
    noSSR
  )
  return <CommissionModal {...props} />
}

type RequestCommissionComponentProps = RequestCommissionProps & {
  closeModal: () => void
  openModal: (payload: string) => void
}

const RequestCommission: FC<RequestCommissionComponentProps> = (props) => {
  const { artistId, fullName, closeModal, canRequestCommission, openModal } = props
  const [showModal, handleShowModal] = useState(false)
  const capitalizedFullName = capitalizeString(fullName)
  const { testId } = useQA()
  if (!canRequestCommission) {
    return null
  }

  return (
    <div className={styles.requestCommission} {...testId('request-commission')}>
      <div className={styles.commissionGrid}>
        <div className={styles.textSection}>
          <h4 className={styles.title}>Commission {capitalizedFullName}</h4>
          <p className={styles.text}>
            If you’re interested in commissioning this artist for a custom artwork, inquire here.
          </p>
        </div>
        <button
          type='button'
          className={styles.contactButton}
          {...testId('contact-button')}
          onClick={() => {
            updateDataLayer({
              event: 'commission start',
            })
            handleShowModal(true)
            openModal('commissionModal')
          }}
        >
          <p className={styles.buttonTitle}>Contact Our Curators</p>
        </button>
        {showModal && (
          <Modal name={COMMISSION_MODAL}>
            <LaunchModal closeModal={closeModal} artistId={artistId} page='artist-profile' />
          </Modal>
        )}
      </div>
    </div>
  )
}

export default RequestCommissionConnector(RequestCommission)
